<template>
  <nuttrema-layout-form-standard :edit="edit">
    <el-form slot="center">
      <section>
        <h4 class="section-title">{{ $t('label.set_program_cover') }}</h4>
        <el-upload
           action="action"
           class="avatar-uploader"
          :class="{ 'is-disabled': !edit }"
          :drag="true"
          :httpRequest="onUploadProgramCover"
          :disabled="!edit"
          :show-file-list="false"
          :before-upload="beforeUploadProgramCover"
          :on-success="onUploadProgramCoverSuccess">
          <div class="hover-info" :class="{ 'is-show': !imageUrl }">
            <i class="el-icon-upload"></i>
            <p>{{ $t('label.drop_file_here') }}</p>
          </div>
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
        </el-upload>
        <div class="section-help">
          <p>{{ $t('label.jpg_png_files', { value: '500kb' }) }}</p>
        </div>
      </section>
    </el-form>
    <template slot="footer">
      <div class="footer-row">
        <popover-question-alert
           buttonTitle="label.remove_program_cover"
           buttonType="danger"
           popoverWidth="280"
           buttonSize="small"
          :popoverShouldShow="true"
          @confirmed="onRemoveProgramCover">
        </popover-question-alert>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-program-cover-image',
  props: {
    ProgramDetails: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    saveError: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
    PopoverQuestionAlert,
  },
  computed: {
    imageUrl() {
      const path = get(this.ProgramDetails, 'data.CoverImage.path', false);
      const filename = get(this.ProgramDetails, 'data.CoverImage.thumbnails.large.filename', false);
      return path && filename ? `${process.env.IMAGES_ROOT}${path}${filename}` : null;
    },
  },
  methods: {
    onCancelClick() {
      this.$emit('cancel');
    },
    onUploadProgramCover(options) {
      this.$emit('uploadCoverImage', options.file);
    },
    onRemoveProgramCover() {
      this.$emit('removeCoverImage');
    },
    onUploadProgramCoverSuccess() {
      this.$emit('uploadCoverImageSuccess');
    },
    beforeUploadProgramCover() {},
  },
};
</script>

<style lang="scss">
  @import '~assets/styles/component/avatar-uploader';
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/cover-image/form-program-cover-image.vue